import React from "react"
import {Helmet} from "react-helmet";
import Appbar from "./appbar"
import Social from "./social";
import Credits from "./credits"
import Container from "react-bootstrap/Container"


export default ({children}) => (
    <Container id="main" fluid={true}>
        <Helmet>
            <meta charSet="utf-8"/>
            <title>Blauigris</title>
            {/*<link*/}
            {/*    rel="stylesheet"*/}
            {/*    href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"*/}
            {/*    integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"*/}
            {/*    crossOrigin="anonymous"*/}
            {/*/>*/}

        </Helmet>
        <Appbar/>
        <Social/>
        {children}
        <Credits/>
    </Container>


)